import { actionButtonStyle, topBannerContentStyle } from '@bingads-webui-react/notification-center';

export const miniCalloutStyle = () => {
  return {
    content: topBannerContentStyle,
    calloutTargetContainer: {
      display: 'inline-block',
      cursor: 'pointer',
      flexShrink: 0,
    },
    calloutCloseButton: {
      top: 9,
      width: 12,
      right: 8,
      border: '0px !important',
      height: '13px !important',
      padding: '0px 0px 0px 0px !important',
      position: 'absolute !important',
      maxWidth: 12,
      minWidth: '12px !important',
      background: 'inherit !important',
      maxHeight: 13,
      minHeight: 13,
    },
    popover: {
      zIndex: 1110000, // should be larger than z-index of floating banner
    },
    button: {
      ...actionButtonStyle,
      '&:hover, &:active, &:focus': {
        '& .iconba-OpenInNewWindow': {
          display: 'block',
        },
      },
    },
    innerText: {
      fontSize: 12,
    },
    innerTextInLink: {
      textDecoration: 'underline',
    },
    openIcon: {
      position: 'absolute',
      top: 4,
      right: 4,
      display: 'none',
    },
    openIconInLink: {
      paddingLeft: 4,
    },
    title: {
      minWidth: '232px',
      fontSize: '20px',
      lineHeight: '28px',
      paddingBottom: '10px',
      fontWeight: '600',
    },
  };
};

export const calloutContentStyle = () => {
  return {
    link: {
      fontSize: '16px !important',
      fontFamily: 'Segoe UI !important',
      fontWeight: '400 !important',
      lineHeight: '19px !important',
      color: '#0078D4 !important',
      padding: '5px !important',
      height: 'auto !important',
      whiteSpace: 'normal !important',
      textAlign: 'left !important',
      minWidth: '232px !important',
    },
    message: {
      fontFamily: 'Segoe UI',
      minWidth: '232px',
      fontSize: '12px',
      lineHeight: '22px',
      paddingBottom: '10px',
    },
  };
};
